"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WattSecond = exports.WattHour = exports.GigaWattHour = exports.MegaWattHour = exports.KiloWattHour = void 0;
var uom_1 = require("uom");
var UnitTimes = require("../unit-times");
var power_1 = require("./power");
var duration_1 = require("./duration");
// These units have a dependency on power, but power has a dependency on energy so we need a separate module for them.
exports.KiloWattHour = UnitTimes.powerByDuration("KiloWattHour", power_1.KiloWatt, duration_1.Hour);
exports.MegaWattHour = UnitTimes.powerByDuration("MegaWattHour", power_1.MegaWatt, duration_1.Hour);
exports.GigaWattHour = UnitTimes.powerByDuration("GigaWattHour", power_1.GigaWatt, duration_1.Hour);
exports.WattHour = UnitTimes.powerByDuration("WattHour", power_1.Watt, duration_1.Hour);
exports.WattSecond = UnitTimes.powerByDuration("WattSecond", power_1.Watt, uom_1.BaseUnits.Second);
//# sourceMappingURL=energy2.js.map